var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9113 29.8985C25.4097 29.8985 29.8671 25.4441 29.8671 19.9492C29.8671 14.4544 25.4097 10 19.9113 10C14.4129 10 9.95557 14.4544 9.95557 19.9492C9.95557 25.4441 14.4129 29.8985 19.9113 29.8985Z",
    fill: "#FF6200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9247 16.7357L19.6694 25.0075L14.8852 21.4777L15.7693 20.2688L19.2683 22.8504L23.6659 15.9288L24.9247 16.7357Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOk);
export default __webpack_public_path__ + "static/media/icon-ok.96bdc106e89b15d9c9b7a20686ffe06f.svg";
export { ForwardRef as ReactComponent };